(function () {
  function initFloatingResources(root) {
    var toggles = root.querySelectorAll('[data-resource-toggle]');
    var items = root.querySelectorAll('.a2k-floating-resources__item');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = toggle.closest('.a2k-floating-resources__item');
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });

    document.addEventListener('click', function (e) {
      items.forEach(function (i) {
        if (!i.contains(e.target)) i.classList.remove('is-open');
      });
    });

    root.querySelectorAll('.a2k-floating-resources__panel').forEach(function (panel) {
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    var lightbox = document.querySelector('[data-image-lightbox]');
    if (!lightbox) return;
    var lightboxImg = lightbox.querySelector('[data-image-lightbox-img]');

    function openLightbox(src, alt) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.hidden = false;
      document.body.classList.add('a2k-lightbox-open');
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxImg.src = '';
      document.body.classList.remove('a2k-lightbox-open');
    }

    root.querySelectorAll('[data-image-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox(trigger.getAttribute('data-full-src'), trigger.getAttribute('data-full-alt'));
      });
    });

    lightbox.querySelector('[data-image-lightbox-close]').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  document.querySelectorAll('[data-a2k-floating-resources]').forEach(initFloatingResources);
})();


/* Quote form: tell the sales team which product/page the request came from.
   Fills the selected option + SKU at submit time and puts a context line at the top of the message. */
(function () {
  document.querySelectorAll('.a2k-floating-resources__quote-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var title = (form.querySelector('[name="contact[Product]"]') || form.querySelector('[name="contact[Page]"]') || {}).value || '';
      var url = (form.querySelector('[data-quote-url]') || {}).value || location.href;
      var option = form.querySelector('[data-quote-option]');
      var sku = form.querySelector('[data-quote-sku]');
      var listEl = form.querySelector('[data-quote-variants]');
      var vid = new URLSearchParams(location.search).get('variant');
      if (!vid) {
        var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
        vid = idInput ? idInput.value : '';
      }
      if (listEl && vid) {
        listEl.getAttribute('data-quote-variants').split('||').forEach(function (row) {
          var p = row.split('~');
          if (p[0] === String(vid)) {
            if (option) option.value = p[1] || '';
            if (sku) sku.value = p[2] || '';
          }
        });
      }
      var bits = [title];
      if (option && option.value && option.value !== 'Default Title') bits.push(option.value);
      if (sku && sku.value) bits.push('SKU ' + sku.value);
      var line = 'Quote request for: ' + bits.filter(Boolean).join(' / ') + '\nPage: ' + url;
      var body = form.querySelector('[data-quote-body]');
      if (body && body.value.indexOf('Quote request for:') !== 0) {
        body.value = line + (body.value.trim() ? '\n\n' + body.value : '');
      }
    });
  });
})();
